import React from "react";
import './chapter-activity-detail.scss';
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";
import CwContentViewer from "../../common/cw-content-viewer/cw-content-viewer";

class ChapterActivityDetail extends React.Component {


    state = {
        showQuestionDetail : false
    }


    toggleBack = () => {

        this.props.back && this.props.back()
    }

    toggleMenu(key) {
        this.setState({ showQuestionDetail: !this.state.showQuestionDetail })
    }

    goToChapterListScreen = () => {
        this.props.goToChapterListScreen && this.props.goToChapterListScreen()
    }

    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb '>
                <span className="bread-crumb-title" onClick={this.goToChapterListScreen}>{`${this.props.selectedClass || ""} >`}</span>
                <span className='pl-2 bread-crumb-title' onClick={() => this.toggleBack()}>{`${this.props.chapterTitle || ""}`}</span>
                {/* <span className='pl-2'>{this.props.selectedElo?.conceptTitle} {`>`} </span>
                <span className='active pl-2'>{this.props.selectedElo?.title}</span> */}
            </div>
        )
    }


    render() {
        return (
            <div className="chapter-activity-detail">
                <div className='' >
                    <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.toggleBack()} />
                </div>
                <div className="p-3">
                    <div className='row align-items-center heading-wrapper mt-2 p-2'>
                        <img className="case-study-bg" src={getImageSource(ImageConstants.ACTIVITY_BG)} />
                        <div className='col-5 d-flex align-items-center'>
                            <div>
                                <img className='orange-play-icon mr-2' src={getImageSource(ImageConstants.CHAPTER_ACTIVITY_ICON)} />
                            </div>
                            <div>
                                <div className="header-text">{`Activities`}</div>
                                <div className=''>{this.renderBreadcrumb()}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="position-relative mt-3">
                    <img className="video-detail-header-image" src={getImageSource(ImageConstants.VIDEO_DETAIL_HEADER_IMAGE)} />

                    {
                        this.props.chapterActivityInfo.questions.map((item) => (
                            <>
                                <div className="video-detail-wrapper">
                                    <div className="sub-heading d-flex p-4">
                                        <CwContentViewer from='case_study' content={item.activityTitle} />
                                        {/* <div className="ml-2">
                                            <img className="download-icon" src={getImageSource(ImageConstants.CASE_STUDY_DOWNLOAD_ICON)} />
                                        </div> */}
                                    </div>
                                    <div className="video-detail-divider"></div>

                                    <div className="question-title-info p-4">
                                        <span className="sub-heading mt-2">Learning Objective</span>
                                        <CwContentViewer content={item.title} />
                                        {
                                            item.images.length ?
                                                item.images.map(image => (
                                                    <img className="case-study-image" src={image.imageUrl} />
                                                ))

                                                : <></>
                                        }
                                        <div className="sub-heading mt-2">Materials required</div>
                                        <CwContentViewer content={item.answer} />
                                        <div className="mt-3">
                                            <div className="questions-and-solutions-card">
                                                <img className="case-study-bg" src={getImageSource(ImageConstants.ACTIVITY_QUESTION_BG)} />
                                                <div className="d-flex justify-content-between align-items-center cursor-pointer p-3" onClick={() => this.toggleMenu('case_study_expand')}>
                                                    <div className="d-flex align-items-center">
                                                        <div className="mr-2">
                                                            <img className="book-with-apple" src={getImageSource(ImageConstants.ACTIVITY_QUESTION_ICON)} />
                                                        </div>
                                                        <div className="heading">Procedure</div>
                                                    </div>
                                                    <div>
                                                        <img className="arrow-size-for-case-study" src={getImageSource(this.state.showQuestionDetail ? ImageConstants.ARROW_UP_ANGLE : ImageConstants.ARROW_DOWN_ANGLE)} />
                                                    </div>
                                                </div>

                                                {
                                                    this.state.showQuestionDetail ?
                                                        <>
                                                            <div className='divider mt-1 mb-1'></div>
                                                            <div className="p-3">
                                                                <div className="p-4 question-and-answer">
                                                                    <CwContentViewer content={item.solution} />
                                                                </div>
                                                            </div>

                                                        </>
                                                        :
                                                        <></>
                                                }
                                                <div>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </>
                        ))
                    }




                </div>


            </div>
        )
    }

}

export default ChapterActivityDetail;